function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.585 9.494l8.326 8.302a.698.698 0 00.985-.988L2.066 9l7.83-7.808a.698.698 0 10-.985-.988L.585 8.506a.697.697 0 000 .988z",
  fill: "#fff"
});

function SvgIconArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    fill: "none"
  }, props), _ref);
}

export default SvgIconArrowLeft;